<template>
  <div class="back-container">
    <h2>场景联动1</h2>
    <div class="search">
      <el-button @click="create" type="primary">创建规则</el-button>
      <el-input
        v-model.trim="searchKey"
        placeholder="请输入规则名称"
        suffix-icon="el-icon-search"
      ></el-input>
      <el-button
        class="search-key"
        @click="search"
        type="primary">
        搜索
      </el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="ruleName"
        label="规则名称"
        width="300">
      </el-table-column>
      <el-table-column
        prop="ruleDescription"
        label="规则描述"
        width="350">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="ruleStatus"
        :formatter="statusFormate"
        label="云端运行状态">
      </el-table-column>
      <el-table-column
        prop="address"
        width="250"
        label="云端操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="cheeck(scope.row)">查看
          </el-button>
          <el-button
            size="mini"
            type="text"
            @click="handleStart(scope.$index, scope.row)">{{startFormater(scope.row.ruleStatus)}}
          </el-button>
          <el-button
            v-if="scope.row.ruleStatus===1"
            size="mini"
            type="text"
            @click="trigger(scope.row.ruleId)">触发
          </el-button>
          <el-button
            size="mini"
            type="text"
            @click="showLog(scope.row)">日志
          </el-button>
          <el-button
            size="mini"
            type="text"
            @click="deleteRule(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNumber"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
    <div>
      <p class="title">场景联动新手引导</p>
      <p class="des">场景联动类型的规则可以配置设备或时间纬度的触发及过滤条件，
        并通过执行动作输出设备或其他规则，实现海量设备场景联动。<span @click="showHelp" style="cursor: pointer;">使用文档</span></p>
      <div>
        <el-steps :space="300" :active="active" finish-status="success">
          <el-step title="新建规则"></el-step>
          <el-step title="配置触发条件"></el-step>
          <el-step title="配置过滤条件"></el-step>
          <el-step title="配置执行动作"></el-step>
          <el-step title="手动触发执行动作"></el-step>
          <el-step title="启动规则"></el-step>
        </el-steps>
      </div>
    </div>
    <instruction :dialogVisible.sync="dialogVisible"></instruction>
    <creat-rule :creatDialogVisible.sync="creatVisible" @refresh="getRules"></creat-rule>
  </div>
</template>

<script>
import Instruction from '@/components/ruleEngine/Instruction.vue'
import creatRule from '@/components/ruleEngine/creatRule.vue'
import { getrules, startmode, deleteRule, triggerRule } from '@/api/ruleEngine.js'
// import { dateFormat } from '@/assets/js/tools.js'
export default {
  name: 'SceneLink',
  components: {
    Instruction,
    creatRule
  },
  data () {
    return {
      totalCount: 0,
      pageNumber: 1,
      pageSize: 10,
      searchCondition: '',
      creatVisible: false,
      dialogVisible: false,
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }],
      searchKey: '',
      active: 0,
      tableData: []
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    getRules (searchCondition = '') {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        searchCondition
      }
      getrules(params).then(res => {
        console.log('res===', res.data)
        this.tableData = res.data.ruleList
        this.totalCount = res.data.recordCount
      })
    },
    statusFormate (row, column, cellValue, index) {
      switch (cellValue) {
        case 0:
          return '未启动'
        case 1:
          return '已启动'
        case 2:
          return '已停止'
      }
    },
    create () {
      this.creatVisible = true
    },
    cheeck (row) {
      this.$router.push({ name: 'sene-detaile', params: row })
    },
    showLog (row) {
      this.$router.push({ name: 'sene-log', params: row })
    },
    showHelp () {
      this.dialogVisible = true
    },
    search () {
      this.pageNumber = 1
      this.getRules(this.searchKey)
    },
    handleStart (sIndex, sRow) {
      let mode = sRow.ruleStatus
      if (mode === 0) {
        mode = 1
      } else if (mode === 1) {
        mode = 0
      } else {
        mode = 1
      }
      startmode({ ruleId: sRow.ruleId, startMode: mode }).then(res => {
        this.getRules()
      }).then(() => {
        if (mode === 1) {
          this.$message({
            type: 'success',
            message: '启动成功'
          })
        } else if (mode === 0) {
          this.$message({
            type: 'info',
            message: '已停止'
          })
        }
      }).catch(() => {
      })
    },
    handleSizeChange (value) {
      this.pageNumber = 1
      this.pageSize = value
      this.getRules(this.searchKey)
    },
    handleCurrentChange (value) {
      this.pageNumber = value
      this.getRules(this.searchKey)
    },
    startFormater (status) {
      switch (status) {
        case 0:
          return '启动'
        case 1:
          return '停止'
      }
    },
    deleteRule () {
      this.$confirm('是否删除该场景？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        deleteRule({ ruleId: arguments[1].ruleId }).then(res => {
          this.getRules()
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
        }).catch(() => {
          this.$message({
            type: 'warn',
            message: '删除失败'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    },
    trigger (ruleId) {
      triggerRule({ ruleId }).then(res => {
        this.$message({
          type: 'success',
          message: '触发成功'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .back-container {
    padding: 0 15px;
  }

  .search {
    display: flex;
    margin-top: 15px;
    flex-direction: row;

    .el-input {
      width: 200px;
      margin-left: 20px;
    }
  }

  .el-table {
    margin: 10px 0;
  }

  .des {
    color: gray;

    span {
      color: #0d9bf2;
    }
  }

  .el-steps {
    margin-top: 20px;
  }
  .search-key{
    margin-left: 15px;
  }
</style>
